<template>
  <v-card class="container white--text" rounded>
    <v-tabs v-model="selectedTab" class="tabs" slider-color="transparent" fixed-tabs>
      <v-tab>My Account</v-tab>
      <v-tab>Teams Licenses</v-tab>
      <!-- <v-tab>Manage Coaches</v-tab> -->
      <v-tab-item>
        <!-- @re-authenticate="reAuthenticate" -->
        <my-account @purchase-licenses-prompt="buyMoreLicenses"></my-account>
      </v-tab-item>
      <v-tab-item>
        <manage-team-licenses-vue @purchase-licenses-prompt="
            buyMoreLicenses
          "></manage-team-licenses-vue>
      </v-tab-item>
      <!-- <v-tab-item>
        <manage-coaches-vue></manage-coaches-vue>
      </v-tab-item> -->
    </v-tabs>
    <!-- <re-authenticate
      v-if="reAuthenticateVisible"
      :visible="reAuthenticateVisible"
      :key="reAuthenticateKey"
      @re-authenticated="reAuthenticated" /> -->
  </v-card>
</template>

<script>
// import ManageCoachesVue from "./ManageCoaches.vue"
import Loading from "@/components/shared/common/Loading.vue"
import ErrorPage from "@/components/shared/common/Error.vue"

export default {
  name: "ManageSubscriptions",
  data() {
    return {
      selectedTab: 0,
      // reAuthenticateVisible: false,
      // reAuthenticateKey: false,
    }
  },
  components: {
    MyAccount: () => ({
      component: import(/* webpackChunkName: "MyAccount" */ "./MyAccount.vue"),
      // component: asyncComponentTester(import("./MyAccount.vue"), 1000),
      loading: Loading,
      error: ErrorPage,
      delay: 200,
      timeout: 2000,
    }),
    // MyAccountVue,
    ManageTeamLicensesVue: () => ({
      component: import(/* webpackChunkName: "ManageTeamLicensesVue" */ "./ManageTeamLicenses.vue"),
      // component: asyncComponentTester(import("./MyAccount.vue"), 1000),
      loading: Loading,
      error: Error,
      delay: 200,
      timeout: 2000,
    }),
    // ReAuthenticate: () =>
    //   /* webpackChunkName: "reAuthenticate" */ import(
    //     "@/components/shared/common/cards/ReAuthenticate.vue"
    //   ),
  },
  mounted() {
    if (this.$route.params.selectedTab) {
      this.selectedTab = this.$route.params.selectedTab
    }
  },
  methods: {
    // reAuthenticate() {
    //   this.reAuthenticateVisible = true
    //   this.reAuthenticateKey = !this.reAuthenticateKey
    // },
    // reAuthenticated() {
    //   this.reAuthenticateVisible = false
    //   this.reAuthenticateKey = !this.reAuthenticateKey
    // },
    buyMoreLicenses(payload) {
      this.$emit("purchase-licenses-prompt", payload)
    },
  },
}
</script>

<style lang="sass" scoped>
@import '@/assets/sass/_variables.sass'

:deep(.v-tabs-bar)
  background-color: transparent !important


:deep(.v-item-group)
  border-radius: 10px

:deep(.v-window)
  margin-top:2rem
.container
  background-image: $bg-green-gradient
  margin: 0px
  max-width: 100%
  padding: 1.6rem 1.6rem 4rem 1.6rem
  .tabs
    max-width: 1100px
    min-width: 630px

  display: flex
  justify-content: center
  .v-slide-group__wrapper
    .v-slide-group__content.v-tabs-bar__content
      .v-tab
        color: green
        background-color: transparentize(#FFF, 0.4 )
        &:nth-child(2)
          border: 1px solid white
          border-radius: 10px 0 0 10px
        &:nth-child(3)
          border-top: 1px solid white
          border-bottom: 1px solid white
        &:nth-child(3)
          border: 1px solid white
          border-radius: 0 10px 10px 0

      .v-tab--active
        border-radius: inherit
        background-color: #FFF !important
</style>
